jQuery( '.accordion-cards-slider #cardsSlider' ).slick( {
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 4000,
  pauseOnHover: true,
  pauseOnFocus: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 501,
      settings: {
        slidesToShow: 1,
      }
    }
  ]
} );

jQuery( '#cardsSlider .card .view-specs' ).on( 'click', function() {
  var id = jQuery( this ).attr( 'spec-id' );

  jQuery( '#cardsSlider .card[spec-id=' + id + '] .overlay' ).fadeIn();
} );

jQuery( '#cardsSlider .card .overlay .close-specs' ).on( 'click', function() {
  var id = jQuery( this ).attr( 'spec-id' );

  jQuery( '#cardsSlider .card[spec-id=' + id + '] .overlay' ).fadeOut();
} );